import api from "../api/api";

export const CouponService = {
  // Müştərinin öz kuponları (login tələb olunur)
  my: async () => {
    const response = await api.get("customer/coupons");
    return response.data; // { coupons: [...] }
  },
};
